
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signin from "./Component/Signin.tsx";
import Header from "./Component/Header.tsx";
import Footer from "./Component/Footer.tsx";
import Signup from "./Component/Signup.tsx";
import Gallary from "./Component/Gallary.tsx";
import Contactus from "./Component/contactus.tsx";
import Aboutus from "./Component/aboutus.tsx";
import HowItWork from "./Component/howitwork.tsx";
import Blog from "./Component/blog.tsx";
import Blogdetails from "./Component/blogdetails.tsx";
import "./index.css"
import { Home } from "./Component/Home.tsx";
import LinkContext from "./Component/LinkContext.tsx";
import PdfFile from "./Component/PdfFile.tsx";
import Bio from "./Component/bio.tsx";
import Restaurantmenu from "./Component/restaurantmenu.tsx";
import Productsstore from "./Component/productsstore.tsx";
import Eventforms from "./Component/eventforms.tsx";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import TermsOfUse from "./Component/termsandcondition.tsx";
import PrivacyPolicy from "./Component/privacypolicy.tsx";
import WiFi from "./Component/wifi.tsx";
import CookieBanner from "./Component/CookieBanner.tsx";


// import Pricing from "./Component/pricing.tsx";

export default function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/login" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/contact-us" element={<Contactus />} />
        {/* <Route path="/pricing" element={<Pricing />} /> */}
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/how-it-works" element={<HowItWork />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Blogdetails />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/" element={<Home />}>
          <Route index element={<LinkContext />} />
          <Route path="tabgallery" element={<Gallary />} />
          <Route path="tabpdf" element={<PdfFile />} />
          <Route path="tabeventforms" element={<Eventforms />} />
          <Route path="tabproductsstore" element={<Productsstore />} />
          <Route path="tabrestaurantmenu" element={<Restaurantmenu />} />
          <Route path="tabbio" element={<Bio />} />
          <Route path="tabwi-fi" element={<WiFi />} />
        </Route>
      </Routes>
      <Footer />
      <CookieBanner />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router >
  );
}
